import { render, staticRenderFns } from "./CustomerListWithProfile.vue?vue&type=template&id=f8080c1e&"
import script from "./CustomerListWithProfile.vue?vue&type=script&lang=js&"
export * from "./CustomerListWithProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports